import authApi from '../../services/authApi'
import encrypt from '../../mixins/encrypt'

const SET_AUTH_SERVICE = "SET_AUTH_SERVICE"
const SET_FCM_TOKEN = "SET_FCM_TOKEN"

const state = {
	authService: null,
	fcmToken: null,
}

const mutations = {
	[SET_AUTH_SERVICE](state, data) {
		state.authService = data
	},
	[SET_FCM_TOKEN](state, data) {
		state.fcmToken = data
	}
}

const actions = {
	async registerPenduduk({ commit }, data) {
		return await authApi.registerPenduduk(data)
	},
	async sendLinkEmailVerification({ commit, getters }, data) {
		let token = getters.getAuthService.token
		return await authApi.sendLinkEmailVerification(token, data)
	},
	async verifyLinkEmailVerification({ commit, getters }, data) {
		let token = getters.getAuthService.token
		return await authApi.verifyLinkEmailVerification(token, data)
	},
	async loginUser({ commit }, data) {
		return await authApi.loginUser(data)
	},
	async loginUserByDeveloper({ commit }, data) {
		return await authApi.loginUserByDeveloper(data)
	},
	setAuthService({ commit, state }, data) {
		localStorage.setItem('authService', JSON.stringify(data))
		commit(SET_AUTH_SERVICE, data)
	},
	async logoutUser({ getters }) {
		let token = getters.getAuthService.token
		return await authApi.logoutUser(token)
	},
	simpanLogin({ commit }, data) {
		localStorage.setItem('akun', JSON.stringify(data))
	},
	setFcmToken({ commit }, data) {
		commit(SET_FCM_TOKEN, data)
		localStorage.setItem('fcmToken', data)
	},
	hapusLoginTersimpan() {
		localStorage.removeItem('akun')
	},
	async fetchCaptcha({ commit }, id) {
		return await authApi.fetchCaptcha(id)
	},
}

const getters = {
	getAuthService: state => {
		if (!localStorage.authService) {
			return {
				isAuthenticated: false,
				currentRole: {
					id_role: null,
					nama_role: null
				},
				role: [],
				token: ''
			}
		} else {
			let authService = JSON.parse(localStorage.authService)
			authService.token = encrypt.methods.decrypt(authService.token)
			return authService
		}
	},
	getDataLoginTersimpan: state => {
		if (localStorage.akun) {
			return JSON.parse(localStorage.akun)
		} else {
			return {
				username: '',
				password: ''
			}
		}
	},
	getFcmToken: state => {
		if (state.fcmToken) {
			return state.fcmToken
		} else {
			if (localStorage.fcmToken) {
				return localStorage.fcmToken
			} else {
				return false
			}
		}
	}
}

export default {
	state,
	mutations,
	actions,
	getters
}